module.exports = require('./helpers/bundle-url').getBundleURL('lldAp') + "logo.c51670a8.svg";